import { Paragraph } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const RentalPaymentHeader = () => {
  const { t } = useTranslation(['terminateContract'])

  return (
    <Paragraph className="mb-6 leading-6" large>
      {t('terminateContract:texts.paymentInfoReasonRental')}
    </Paragraph>
  )
}
